(function () {
  if (!/CriOS/i.test(navigator.userAgent)) return;

  var root = document.documentElement;
  var viewport = window.visualViewport;
  var scheduled = false;

  root.classList.add('lexie-ios-chrome');

  function updateViewportHeight() {
    scheduled = false;
    var height = viewport ? viewport.height : window.innerHeight;

    if (height > 0) {
      root.style.setProperty('--lexie-visible-viewport-height', height + 'px');
    }
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateViewportHeight);
  }

  updateViewportHeight();
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('orientationchange', scheduleUpdate, { passive: true });

  if (viewport) {
    viewport.addEventListener('resize', scheduleUpdate, { passive: true });
    viewport.addEventListener('scroll', scheduleUpdate, { passive: true });
  }
})();
